import {
    AccountApprovalContext,
    type AccountApprovalContextType,
} from '@context/account-approval/account-approval-context';
import {
    AccountApprovalActions,
    type AccountApprovalActionsType,
} from '@context/account-approval/account-approval-context-actions';
import { useContext } from 'react';

export const useAccountApproval = (): AccountApprovalContextType => {
    const accountApprovalStateContext = useContext(AccountApprovalContext);

    return accountApprovalStateContext;
};

export const useAccountApprovalActions = (): AccountApprovalActionsType => {
    const accountApprovalActionsContext = useContext(AccountApprovalActions);

    return accountApprovalActionsContext;
};
